import { render } from "./TraqrReference.vue?vue&type=template&id=7cffa373"
import script from "./TraqrReference.vue?vue&type=script&lang=js"
export * from "./TraqrReference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__